import { render, staticRenderFns } from "./nutrient.vue?vue&type=template&id=3ee4a261&scoped=true&"
import script from "./nutrient.vue?vue&type=script&lang=js&"
export * from "./nutrient.vue?vue&type=script&lang=js&"
import style0 from "./nutrient.vue?vue&type=style&index=0&id=3ee4a261&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee4a261",
  null
  
)

component.options.__file = "nutrient.vue"
export default component.exports